module.exports = __webpack_public_path__ + "static/media/05fa-standard.292e0abd.jpg";